<template>
    <review-component v-bind="$props" v-on="$listeners" style="clear: right;">
        &#60;img src="{{tr(component.src)}}" alt="{{tr(component.alt)}}"/&#62;

        <template v-if="component.link">
            &#60;a href="{{component.link.to || component.link.href}}"/&#62;
        </template>
        <b-img :src="component.src" class="float-right rounded" width="80" height="80" blank-color="#ddd" style="object-fit: contain; background: #ddd"/>
    </review-component>
</template>

<script>
import ReviewComponent from "@components/review/review-component.vue";

export default {
    name: `review-component-image`,
    extends: ReviewComponent,
    components: {ReviewComponent}
}
</script>

<style lang="scss" scoped>
</style>
